var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1269_10801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    y: 0.5,
    width: 21,
    height: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1269_10801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78856 18C6.39977 18 6.06698 17.8616 5.79019 17.5848C5.5134 17.308 5.375 16.9752 5.375 16.5864V5.75H4.9375C4.81354 5.75 4.70964 5.708 4.62578 5.624C4.54193 5.54 4.5 5.43595 4.5 5.31184C4.5 5.18774 4.54193 5.0839 4.62578 5.00034C4.70964 4.91678 4.81354 4.875 4.9375 4.875H8C8 4.69446 8.06701 4.5371 8.20103 4.40294C8.33505 4.26891 8.49241 4.2019 8.67309 4.2019H12.5769C12.7576 4.2019 12.9149 4.26891 13.049 4.40294C13.183 4.5371 13.25 4.69446 13.25 4.875H16.3125C16.4365 4.875 16.5404 4.917 16.6242 5.001C16.7081 5.085 16.75 5.18905 16.75 5.31316C16.75 5.43726 16.7081 5.54109 16.6242 5.62466C16.5404 5.70822 16.4365 5.75 16.3125 5.75H15.875V16.5864C15.875 16.9752 15.7366 17.308 15.4598 17.5848C15.183 17.8616 14.8502 18 14.4614 18H6.78856ZM15 5.75H6.25V16.5864C6.25 16.7435 6.30046 16.8726 6.40138 16.9736C6.50244 17.0745 6.6315 17.125 6.78856 17.125H14.4614C14.6185 17.125 14.7476 17.0745 14.8486 16.9736C14.9495 16.8726 15 16.7435 15 16.5864V5.75ZM9.14472 15.375C9.26897 15.375 9.37287 15.3331 9.45644 15.2492C9.54 15.1654 9.58178 15.0615 9.58178 14.9375V7.9375C9.58178 7.81354 9.53978 7.70963 9.45578 7.62578C9.37178 7.54193 9.26773 7.5 9.14363 7.5C9.01952 7.5 8.91569 7.54193 8.83213 7.62578C8.74856 7.70963 8.70678 7.81354 8.70678 7.9375V14.9375C8.70678 15.0615 8.74878 15.1654 8.83278 15.2492C8.91664 15.3331 9.02061 15.375 9.14472 15.375ZM12.1064 15.375C12.2305 15.375 12.3343 15.3331 12.4179 15.2492C12.5014 15.1654 12.5432 15.0615 12.5432 14.9375V7.9375C12.5432 7.81354 12.5012 7.70963 12.4172 7.62578C12.3334 7.54193 12.2294 7.5 12.1053 7.5C11.981 7.5 11.8771 7.54193 11.7936 7.62578C11.71 7.70963 11.6682 7.81354 11.6682 7.9375V14.9375C11.6682 15.0615 11.7102 15.1654 11.7942 15.2492C11.8782 15.3331 11.9823 15.375 12.1064 15.375Z",
    fill: "#FF3434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEmojiIcon);
export default __webpack_public_path__ + "static/media/deleteEmojiIcon.43a9085d58c8dd5d2c0438bba945dafe.svg";
export { ForwardRef as ReactComponent };